<template>
  <!-- eslint-disable max-len  -->
  <div class="control">
    <span class="select">
      <select v-model="selected" ref="select" @blur="$emit('blur', $event)" @focus="$emit('focus', $event)" @change="updateLocale">
        <option v-for="option in options" :value="option.id" :key="option.id">
          {{ option.text }}
        </option>
      </select>
      <span class="value">{{ selectedValue }}</span>
      <span aria-hidden="true" class="s-icon"
        ><svg viewBox="0 0 24 24" role="img" aria-hidden="true" class="icon-svg">
          <path d="M7,10L12,15L17,10H7Z"></path></svg
      ></span>
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { setLocale, useI18n, isLocaleSupported } from '@/i18n';
import {
  LABEL_DUTCH_SELF,
  LABEL_ENGLISH_SELF,
  LABEL_FRENCH_SELF,
  LABEL_GERMAN_SELF,
  LABEL_ITALIAN_SELF,
  LABEL_PORTUGUESES_SELF,
  LABEL_RUSSIAN_SELF,
  LABEL_SPANISH_SELF,
} from '@/libs/i18nLabels';

export default defineComponent({
  setup() {
    const i18n = useI18n();

    const selected = ref(i18n.locale.value || 'en');

    // Replace parameter in url
    // const qp = new URLSearchParams(window.location.search.substring(1));

    function updateQueryString() {
      // qp.delete('lang');
      // qp.set('lg', selected.value);
      // window.history.replaceState(null, '', `?${qp.toString()}`);
    }

    function updateLocale() {
      setLocale(i18n, selected.value);
      updateQueryString();
    }

    return { updateLocale, selected };
  },

  props: {},

  emits: ['focus', 'blur'],

  computed: {
    options() {
      return [
        { id: 'en', text: this.$t(LABEL_ENGLISH_SELF) },
        { id: 'en_GB', text: `${this.$t(LABEL_ENGLISH_SELF)} (UK)` },
        { id: 'fr', text: this.$t(LABEL_FRENCH_SELF) },
        { id: 'nl', text: this.$t(LABEL_DUTCH_SELF) },
        { id: 'pt', text: this.$t(LABEL_PORTUGUESES_SELF) },
        { id: 'es', text: this.$t(LABEL_SPANISH_SELF) },
        { id: 'it', text: this.$t(LABEL_ITALIAN_SELF) },
        { id: 'de', text: this.$t(LABEL_GERMAN_SELF) },
        { id: 'ru', text: this.$t(LABEL_RUSSIAN_SELF) },
      ].filter((t) => isLocaleSupported(t.id));
    },

    selectedValue() {
      const selectedValue = this.selected;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const values = this.options as any;

      let v;
      for (let i = 0; i < values.length; i += 1) {
        v = values[i];
        if (v.id === selectedValue) {
          return v.text;
        }
      }
      return '';
    },
  },
});
</script>

<style lang="scss" scoped>
.select {
  display: inline-block;
  max-width: 100%;
  position: relative;
  vertical-align: top;
  height: 2.5em;
  border-radius: 4px;
}

.s-icon {
  align-items: center;
  display: inline-flex;
  font-size: 24px;
  justify-content: center;
  letter-spacing: normal;
  line-height: 1;
  position: absolute;
  right: 0;
  top: 8px;
  text-indent: 0;
  z-index: 0;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: rgba(0, 0, 0, 0.54);
}

.icon-svg {
  height: 24px;
  width: 24px;
  fill: var(--color);
}

.select select {
  cursor: pointer;
  display: block;
  font-size: 1em;
  max-width: 100%;
  outline: none;
  text-rendering: auto !important;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  align-items: center;
  border: 1px solid transparent;
  box-shadow: none;
  line-height: 1.5;
  height: 2.5em;
  z-index: 1;
  opacity: 0;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.value {
  display: block;
  line-height: 1.5;

  padding: calc(0.5em - 1px) 0;
  padding-right: 1.5em;
  font-size: 1rem;
  height: 2.5em;
}
</style>
